import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportSaidaProdutoUseCase } from "../../../presentation/useCases/read/get_report_saida_produto_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportSaidaProdutoUseCase implements IGetReportSaidaProdutoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportSaidaProduto(
    requiredMimeType: ReportMimeType | null,
    IdUsuario: number,
    Funcionario ?: number | null,
    Produtos?: number | null,
    CentroCustos?: number[],
    CentroCustosDestino?: number[],
    DataInicio?: Date | null,
    DataFinal?: Date | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportSaidaProduto(
      requiredMimeType, IdUsuario,Funcionario, Produtos, CentroCustos, CentroCustosDestino, DataInicio, DataFinal
    );

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `SaidaProduto_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
